<template>
  <div class="mobile_wrap_our_service wow fadeInUp">
    <el-row>
      <el-col :span="1" class="header_block"></el-col>
      <el-col :span="22" class="header_block">
        <div class="item itemservice01">
          <!-- <div class="wrap_each_img"> -->
          <img :src="imgOne" class="img_each"/>
          <!-- </div> -->
          <div class="info">
            <h3 class="info_text" style="color:#666">Reliable</h3>
            <p class="info_line"></p>
            <p class="info_p1">靠谱</p>
          </div>
          
        </div>
        <div class="item">
          <div class="info">
            <h3 class="info_text01">Professional</h3>
            <p class="info_line"></p>
            <p class="info_p101">专业</p>
          </div>
        </div>
        <div class="item itemservice02">
          <img :src="imgTwo" class="img_each"/>
          <div class="info">
            <h3 class="info_text">Customization</h3>
            <p class="info_line"></p>
            <p class="info_p1">订制</p>
          </div>
        </div>
        <div class="item">
          <div class="info">
            <h3 class="info_text01">Efficient</h3>
            <p class="info_line"></p>
            <p class="info_p101">高效</p>
          </div>
        </div>
        <div class="item itemservice03">
          <img :src="imgThree" class="img_each"/>
          <div class="info">
            <h3 class="info_text" style="color:#666">Cost Effective</h3>
            <p class="info_line"></p>
            <p class="info_p1" style="color:#666">高性价比</p>
          </div>
        </div>
        <div class="item">
          <div class="info">
            <h3 class="info_text01">Multiple Modification</h3>
            <p class="info_line"></p>
            <p class="info_p101">多次修改</p>
          </div>
        </div>

        <!-- <div class="video_tv">VIDEO</div>
        <div class="video_text">宣传视频</div>-->
      </el-col>
      <el-col :span="1" class="header_block"></el-col>
    </el-row>
    <!-- <el-row >
  <el-col :span="2" class="header_block"></el-col>
  <el-col :span="20">
    <el-row :gutter="20" v-for="(item,index) in videoArray" :key="index">
      <el-col  v-for="(itm,inx) in item" :key="inx" :span="12" class="header_block">
        <div class="big_video_box ">
          <div class="mask_title">{{itm.text}}</div>
                <img class="mask_boxs" :src="itm.url" alt="2020体彩竞猜广告-去赛场篇">
                 <i class="shark"></i>
        </div>
      </el-col>
      </el-row>
  </el-col>
  <el-col :span="2" class="header_block"></el-col>
    </el-row>-->
  </div>
</template>

<script>
export default {
  name: "ourService",
  // props: {
  //   videoArray: {
  //     type: Array,
  //     default: () => {
  //       return []
  //     },
  //   }
  // },
  data() {
    return {
      // serviceArray:[
      //   {url:require('@/assets/imgs/a01.png'),title:'商业视频',titleEng:'Commercial video'},
      //   {url:require('@/assets/imgs/a02.png'),title:'短视频',titleEng:'short video'},
      //   {url:require('@/assets/imgs/a01.png'),title:'视频课程',titleEng:'video course'},
      //   {url:require('@/assets/imgs/a03.png'),title:'多媒体展示',titleEng:'multimedia show'},
      // ],
      imgOne:require('@/assets/imgs/service01.jpg'),
      imgTwo:require('@/assets/imgs/service02.jpg'),
      imgThree:require('@/assets/imgs/service03.jpg')
    };
  },
  mounted() {
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      // const wow = new WOW({
      //   live: false
      // })
      // wow.init()
      new this.$wow.WOW({
        live:true
      }).init()
    })
  },

  // mounted(){
  // 　　window.addEventListener('scroll',this.handleScroll) // 监听滚动事件，然后用handleScroll这个方法进行相应的处理
  // },
  // methods:{
  //   handleScroll(){
  //     this.$nextTick(()=>{
  // 	let scrollTop = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset
  //    if (scrollTop > 60) {
  //      this.logoIndex = 1
  //      this.classNames = "nav_bg_white_add"
  //      this.menuClassNames = "menu_each each_toggle"
  //       } else {
  //      this.logoIndex = 0
  //      this.classNames = "nav_bg_white_reduce"
  //      this.menuClassNames = "menu_each "
  //       }
  // })
  //   }
  // }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.mobile_wrap_our_service {
  .header_block {
    min-height: 10px;
  }
  .info_p1{
    font-size: 14px;
    color: #e5e5e5;
  }
  .info_p101{
    font-size: 14px;
    color: #666;
  }
  .item {
    width: 33.3333%;
    height: 90px;
    //  padding-top:  33.3333%;
    float: left;
    position: relative;
    // background: url("../assets/imgs/p1.jpg") center no-repeat;
   
    .info {
      position: absolute;
      bottom: 10px;
      left: 10px;
      .info_text {
        font-size: 14px;
    color: #cccccc;
    line-height: 24px;
      }
      .info_line {
        width: 30px;
        height: 2px;
        margin: 12px 0 16px;
        background: #666;
      }
       .info_text01 {
        font-size: 14px;
    color: #666;
    line-height: 14px;
      }
      .info_line01 {
        width: 30px;
        height: 2px;
        margin: 12px 0 16px;
        background: #666;
      }
      .info_p {
        font-size: 14px;
        color: #e5e5e5;
      }
    }
  }
  .itemservice01{
// background: url("../assets/imgs/service01.jpg") center no-repeat;
//  background-size: cover;
  }
  .img_each{
    width: 100%;
    height: 100%;
  }
  .itemservice02{
// background: url("../assets/imgs/service02.jpg") center no-repeat;
//  background-size: cover;
  }
  .itemservice03{
// background: url("../assets/imgs/service03.jpg") center no-repeat;
//  background-size: cover;
  }
}
</style>



